import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { FetchPrivateConnectionsRequest } from '~src/bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';

import { FetchPrivateConnectionsRequestAction, fetchPrivateConnectionsRequestSucceeded } from '../actions/FetchPrivateConnectionsRequestAction';
import { IGetPrivateConnectionsResult } from '../serverApi/requests/GetPrivateConnectionsRequest';
import { PrivateConnectService } from '../services/PrivateConnectService';


export function* handleFetchPrivateConnectionsRequest(action: FetchPrivateConnectionsRequestAction) {
    try {
      const privateConnectionResult: IGetPrivateConnectionsResult = yield call(PrivateConnectService.getPrivateConnections);
      yield put(fetchPrivateConnectionsRequestSucceeded(privateConnectionResult.privateConnections));
    } catch(e) {
      yield put(requestFailed(e, Messages.errorUnknown()));
    }
  }

export function* rootPrivateConnectionsSagas(): SagaIterator {
    yield takeLatest(FetchPrivateConnectionsRequest, handleFetchPrivateConnectionsRequest);
  }